import { Component, Input, Output } from '@angular/core';
import { SeaModel } from 'src/app/models/sea/sea-model';
import { EventEmitter } from '@angular/core';
import { MarketSeaProductsModel } from 'src/app/models/sea/market-sea-products.model';
import { TranslateService } from '@ngx-translate/core';
import { ProductHasPricePipe } from 'src/app/shared/product-has-price-pipe/product-has-price.pipe';

export interface ReservationData {
  selectedProduct: MarketSeaProductsModel | null;
  marketProductsDefId: number | null;
  productId: number | null;
  uuid: string | null;
}


@Component({
  selector: 'app-sea-list',
  templateUrl: './sea-list.component.html',
  styleUrls: ['./sea-list.component.scss']
})


export class SeaListComponent {
  @Input() alternativeSegmentStartIndex: number = null;
  @Input() model: SeaModel = null;
  @Input() loading: boolean = false;
  @Output() makeReservation: EventEmitter<ReservationData> = new EventEmitter<ReservationData>();
  @Output() priceInfo: EventEmitter<MarketSeaProductsModel> = new EventEmitter<MarketSeaProductsModel>();
  @Output() priceRequest: EventEmitter<MarketSeaProductsModel> = new EventEmitter<MarketSeaProductsModel>();



  constructor(public translation: TranslateService, private pricePipe: ProductHasPricePipe) {

  }


  _makeReservation(selectedProduct: MarketSeaProductsModel = null, marketProductsDefId = null, productId = null, uuid = null) {
  
      this.makeReservation.emit({selectedProduct,marketProductsDefId,productId, uuid})
    
  
    this.loading = true;
    
  }
  
  _priceRequest(product: MarketSeaProductsModel) {
    this.priceRequest.emit(product);
  }

  async _clickRow(item: MarketSeaProductsModel) {
    const hasPrice = this.pricePipe.transform(item, this.model, 'sea');
    if(hasPrice) {
      this.priceInfo.emit(item)
    } else { // fiyat yoksa
        this.priceRequest.emit(item);
    }
  }
  async _priceInfo(product: MarketSeaProductsModel) {
    this.priceInfo.emit(product)
 
  }

  hasShipInfo(item: any): boolean {
    const info = item?.freights?.shipInfo;
    return !!info && info.trim().toLowerCase() !== 'null';
  }

 

}
